if (!customElements.get('size-guide')) {
  class SizeGuide extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.openButton = this.querySelector('button[command="show-modal"]');
      this.handleOpenClick = this.handleOpenClick.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);

      this.dialog.addEventListener('click', this.handleCloseClick);
      this.openButton.addEventListener('click', this.handleOpenClick);
    }

    disconnectedCallback() {
      this.dialog.removeEventListener('click', this.handleCloseClick);
      this.openButton.removeEventListener('click', this.handleOpenClick);
    }

    handleOpenClick(event) {
      event.preventDefault();

      this.dialog.showModal();
      setTimeout(() => this.dialog.classList.add('opening'));
    }

    handleCloseClick(event) {
      if (!event.target.closest('.size-guide-dialog__content') || event.target.closest('button[command="close"]')) {
        event.preventDefault();
        this.dialog.classList.remove('opening');

        this.dialog.addEventListener('transitionend', () => {
          this.dialog.close();
        }, {once: true})
      }
    }
  }
  
  customElements.define('size-guide', SizeGuide);
}
